var crypto = require('crypto');

var saltChars = '5ZTu3JwhdPTriYluXnglxEM428HBoAyY';

async function generateHash(data, hashOptions) {
  let iterations = hashOptions.iterations;
  try {
    var hash = data;
    for(var i=0; i<iterations; ++i) {
      hash = crypto.createHmac(hashOptions.algorithm, saltChars).update(hash).digest('hex');
    }
    
    return hash;
  } catch (e) {
    throw new Error('Invalid message digest algorithm');
  }
}


/*
ALGORITHMS:
  'DSA',
  'DSA-SHA',
  'DSA-SHA1',
  'DSA-SHA1-old',
  'RSA-MD4',
  'RSA-MD5',
  'RSA-MDC2',
  'RSA-RIPEMD160',
  'RSA-SHA',
  'RSA-SHA1',
  'RSA-SHA1-2',
  'RSA-SHA224',
  'RSA-SHA256',
  'RSA-SHA384',
  'RSA-SHA512',
  'dsaEncryption',
  'dsaWithSHA',
  'dsaWithSHA1',
  'dss1',
  'ecdsa-with-SHA1',
  'md4',
  'md4WithRSAEncryption',
  'md5',
  'md5WithRSAEncryption',
  'mdc2',
  'mdc2WithRSA',
  'ripemd',
  'ripemd160',
  'ripemd160WithRSA',
  'rmd160',
  'sha',
  'sha1',
  'sha1WithRSAEncryption',
  'sha224',
  'sha224WithRSAEncryption',
  'sha256',
  'sha256WithRSAEncryption',
  'sha384',
  'sha384WithRSAEncryption',
  'sha512',
  'sha512WithRSAEncryption',
  'shaWithRSAEncryption',
  'ssl2-md5',
  'ssl3-md5',
  'ssl3-sha1',
  'whirlpool'
*/

const hashOptions = {
    algorithm: 'sha512',
    iterations: 100
}

async function hash (data) { 
    try {
        let hash_res = await generateHash(data, hashOptions)
        return hash_res
    } catch (err) {
    }
    return null;
}

export default {
    hashPass : async function (login, pass) {
        let login_hash = await hash(login)
        if (login_hash) {
            try {
                return await generateHash(pass + login_hash, hashOptions);
            } catch (err) {
            }
        }
        return null;
    }
}